import React from "react"

import {
  MediumBanner,
  LargeBanner,
  ImageText,
  Features,
  Testimonials,
  ContactForm,
  NewContactForm,
  TextContent,
  BannerSlider,
  PageSpacer,
  VideoBlock,
  CenteredCTA,
  MapBlock,
  PricingTable,
  PartnerLogos,
  FeatureBlock,
  HubspotForm,
} from "./"

import { Quote } from "../blog"

export const SliceZone = ({
  slices,
  pageTitle,
  isBlog = false,
  enquiryType,
  category,
  activeColour,
}) => {
  const slice = slices?.map((s) => {
    //create array of all slices where slice_type is 'feature_block'
    const featureBlocks = slices?.filter(
      (slice) => slice?.slice_type === "feature_block"
    )

    switch (s?.slice_type) {
      case "page_spacer":
        return <PageSpacer {...s?.primary} key={s?.id} />
      case "partner_logos":
        return (
          <PartnerLogos
            items={s?.items}
            heading={s?.primary?.heading?.text}
            key={s?.id}
          />
        )
      case "centered_cta":
        return <CenteredCTA {...s?.primary} key={s?.id} />
      case "map_block":
        return <MapBlock {...s?.primary} key={s?.id} />
      case "video_block":
        return <VideoBlock {...s?.primary} key={s?.id} />
      case "pricing_table":
        return <PricingTable items={s?.items} {...s?.primary} key={s?.id} />
      case "banner_slider":
        return <BannerSlider items={s?.items} {...s?.primary} key={s?.id} />
      case "large_banner":
        return <LargeBanner {...s?.primary} key={s?.id} />
      case "medium_banner":
        return <MediumBanner {...s?.primary} key={s?.id} />
      case "image___text":
        return (
          <ImageText
            {...s?.primary}
            items={s?.items}
            key={s?.id}
            isBlog={isBlog}
            category={category}
          />
        )
      case "feature_block":
        return (
          <FeatureBlock
            {...s?.primary}
            items={s?.items}
            key={s?.id}
            activeColour={activeColour}
            solidColour={featureBlocks?.length === 1}
          />
        )
      case "text_content":
        return (
          <TextContent
            {...s?.primary}
            items={s?.items}
            key={s?.id}
            isBlog={isBlog}
          />
        )
      case "features":
        return <Features items={s?.items} {...s?.primary} key={s?.id} />
      case "testimonials":
        return <Testimonials items={s?.items} key={s?.id} />
      case "contact_form":
        return <ContactForm {...s?.primary} key={s?.id} pageTitle={pageTitle} />
      case "contact_form_1":
        return (
          <NewContactForm
            {...s?.primary}
            key={s?.id}
            pageTitle={pageTitle}
            enquiryType={enquiryType}
          />
        )
      case "blog_quote":
        return <Quote {...s?.primary} category={category} />
      case "hubspot_form":
        return <HubspotForm {...s?.primary} key={s?.id} />
      default:
        return <div></div>
    }
  })
  return <div className="slice-zone flex flex-column bg-white">{slice}</div>
}
